var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarmClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2.75V4.03081C17.3696 4.41192 21 8.282 21 13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 8.282 6.63035 4.41192 11.25 4.03081V2.75H10C9.58579 2.75 9.25 2.41421 9.25 2C9.25 1.58579 9.58579 1.25 10 1.25H14C14.4142 1.25 14.75 1.58579 14.75 2C14.75 2.41421 14.4142 2.75 14 2.75H12.75ZM12.75 8C12.75 7.58579 12.4142 7.25 12 7.25C11.5858 7.25 11.25 7.58579 11.25 8V12.9231C11.25 13.1187 11.3264 13.3066 11.463 13.4467L14.463 16.5236C14.7522 16.8202 15.227 16.8262 15.5236 16.537C15.8202 16.2478 15.8262 15.773 15.537 15.4764L12.75 12.618V8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3C6.62485 3 7.21623 3.14327 7.74309 3.39876C5.36624 4.45415 3.45415 6.36624 2.39876 8.74309C2.14327 8.21623 2 7.62485 2 7C2 4.79086 3.79086 3 6 3Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6012 8.74309C21.8567 8.21623 22 7.62485 22 7C22 4.79086 20.2091 3 18 3C17.3752 3 16.7838 3.14327 16.2569 3.39876C18.6338 4.45415 20.5458 6.36624 21.6012 8.74309Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmClock);
export default __webpack_public_path__ + "static/media/alarm-clock.c1d1b3021cbcb9283aac34b7234e2fe7.svg";
export { ForwardRef as ReactComponent };